import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ChevronUpIcon = () => (_jsx("svg", { name: 'chevronUp', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', height: '18px', width: '18px', children: _jsx("path", { d: 'M19.5 15.75L12 8.25L4.5 15.75', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) }));
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const SiteVisitSchedulePreview = ({ productMessages, messages }) => {
    var _a;
    if (!messages) {
        return null;
    }
    return [
        _jsxs("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'rgb(244, 242, 245)',
                padding: '20px',
                height: '100%',
                fontSize: '.9em',
                lineHeight: '1.2em',
                fontWeight: 400,
                borderRadius: '1em',
            }, children: [_jsx("div", { style: { fontWeight: 500, marginBottom: 10 }, children: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.title) !== null && _a !== void 0 ? _a : 'Visit schedule' }), _jsxs("div", { children: [_jsx("div", { style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'end',
                                backgroundColor: 'rgb(231, 225, 255)',
                                borderRadius: '6px',
                                height: '40px',
                                paddingInlineEnd: '16px',
                            }, children: _jsx(ChevronUpIcon, {}) }), _jsx("ul", { style: {
                                borderRadius: '6px',
                                listStyle: 'none',
                                backgroundColor: '#fff',
                                border: '1px solid rgb(229, 231, 235)',
                                maxHeight: '300px',
                                overflowY: 'auto',
                            }, children: Object.values(messages).map((item) => (_jsx("li", { style: { padding: 14 }, children: item || '' }, item))) })] })] }, 'site-visit-schedule-root'),
    ];
};
//# sourceMappingURL=site_visit_schedule.preview.component.js.map